import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "./components/ContactForm";

const services = [
  {
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "汇集电影新闻、电视剧发展动向与影评推荐，第一时间掌握行业动态。",
  },
  {
    icon: "ri-filter-3-line",
    title: "分类筛选",
    desc: "按类型、地区、年份与热度快速筛选影视剧集，精准找到想看的内容。",
  },
  {
    icon: "ri-file-text-line",
    title: "详细介绍",
    desc: "提供剧情简介、上映时间、导演主演等完整信息，观影前做足功课。",
  },
  {
    icon: "ri-magic-line",
    title: "相关推荐",
    desc: "根据题材与标签智能推荐相似作品，帮你发现更多值得一看的影视。",
  },
];

const guideSteps = [
  { step: "01", title: "浏览首页", desc: "通过轮播与分类入口，快速了解当前热门影视与最新资讯。" },
  { step: "02", title: "筛选剧集", desc: "进入分类页，使用类型、地区、年份与排序条件找到心仪作品。" },
  { step: "03", title: "查看详情", desc: "点击卡片进入详情页，阅读剧情简介与相关推荐，决定是否观看。" },
  { step: "04", title: "搜索与分享", desc: "使用顶部搜索查找内容，并通过分享按钮把作品推荐给朋友。" },
];

export default function About() {
  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <div className="mt-4 rounded-lg bg-primary-950 px-6 py-10 md:py-14 relative overflow-hidden">
        <div className="relative z-10 max-w-3xl">
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
            关于欲望之岛
          </h1>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
            欲望之岛是一个综合影视资讯及剧集推荐平台，聚焦电影与电视剧，面向广大追剧人群、影视资讯读者及影评爱好者。我们希望通过清晰的信息组织与友好的浏览体验，帮助你快速获取影视动态、浏览剧集信息，并发现值得一看的精选作品。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-label font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览影视
            </Link>
            <Link
              to="/news"
              className="px-5 py-2.5 rounded-md border border-background-50/30 text-background-50 text-sm font-label hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看资讯
            </Link>
          </div>
        </div>
        <i className="ri-film-line absolute -right-6 -bottom-8 text-[160px] text-primary-900"></i>
      </div>

      {/* 服务内容 */}
      <section className="mt-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">我们提供什么</h2>
        <p className="mt-2 text-sm text-foreground-600">围绕影视爱好者的核心需求，提供四类主要内容服务。</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((s) => (
            <div
              key={s.title}
              className="rounded-lg bg-background-50 border border-background-200 p-5 hover:border-accent-400 transition-colors"
            >
              <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-heading font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 目标用户 */}
      <section className="mt-10 rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
          <div className="lg:col-span-2">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">我们为谁服务</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              无论你是每周追更的剧迷、关注行业动态的资讯读者，还是喜欢写影评的影视爱好者，欲望之岛都希望成为你日常观影决策的可靠帮手。我们把复杂的影视信息整理成清晰的分类与卡片，让你用更少的时间找到更合适的内容。
            </p>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="text-center rounded-lg bg-background-100 py-4">
              <p className="text-2xl font-heading font-bold text-accent-600">16+</p>
              <p className="mt-1 text-xs text-foreground-500">精选影视</p>
            </div>
            <div className="text-center rounded-lg bg-background-100 py-4">
              <p className="text-2xl font-heading font-bold text-accent-600">10+</p>
              <p className="mt-1 text-xs text-foreground-500">资讯文章</p>
            </div>
            <div className="text-center rounded-lg bg-background-100 py-4">
              <p className="text-2xl font-heading font-bold text-accent-600">7</p>
              <p className="mt-1 text-xs text-foreground-500">覆盖地区</p>
            </div>
          </div>
        </div>
      </section>

      {/* 使用说明 */}
      <section className="mt-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">使用说明</h2>
        <p className="mt-2 text-sm text-foreground-600">四步轻松玩转欲望之岛。</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {guideSteps.map((g) => (
            <div key={g.step} className="rounded-lg bg-background-50 border border-background-200 p-5">
              <span className="text-3xl font-heading font-bold text-secondary-500">{g.step}</span>
              <h3 className="mt-3 text-base font-heading font-semibold text-foreground-950">
                {g.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 联系方式 / 反馈 */}
      <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            如果你对内容有建议、发现信息有误，或希望与我们合作，欢迎通过下方表单留言，也可直接发送邮件与我们取得联系。
          </p>
          <ul className="mt-5 flex flex-col gap-3">
            <li className="flex items-center gap-3 text-sm text-foreground-700">
              <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className="ri-mail-line text-lg"></i>
              </span>
              hello@yuwangzhidao.demo
            </li>
            <li className="flex items-center gap-3 text-sm text-foreground-700">
              <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-time-line text-lg"></i>
              </span>
              工作日 09:00 - 18:00
            </li>
            <li className="flex items-center gap-3 text-sm text-foreground-700">
              <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
                <i className="ri-map-pin-line text-lg"></i>
              </span>
              线上内容平台 · 全地区可访问
            </li>
          </ul>
        </div>
        <div className="lg:col-span-2 rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
          <h3 className="text-lg font-heading font-bold text-foreground-950 mb-5">反馈与建议</h3>
          <ContactForm />
        </div>
      </section>

      <div className="h-6"></div>
    </div>
  );
}